import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import {
  MatCardModule,
  MatIconModule,
  MatPaginatorModule,
  MatDividerModule,MatChipsModule,MatTooltipModule
} from "@angular/material";
import { MatTableModule } from "@angular/material/table";
import { MatExpansionModule } from "@angular/material/expansion";
import { AboutComponent } from "./components/about/about.component";
import { ExperienceComponent } from "./components/experience/experience.component";
import { ProjectComponent } from "./components/project/project.component";
import { SkillComponent } from "./components/skill/skill.component";
import { InterestComponent } from "./components/interest/interest.component";
import { AchievementComponent } from "./components/achievement/achievement.component";
import { EducationComponent } from "./components/education/education.component";
import { SharedService } from "./service/shared.service";

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    ExperienceComponent,
    ProjectComponent,
    SkillComponent,
    InterestComponent,
    AchievementComponent,
    EducationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatDividerModule,
    MatChipsModule,MatTooltipModule
  ],
  providers: [SharedService],
  bootstrap: [AppComponent],
})
export class AppModule {}
